import ProductBouquetActions from "@redux/feature/Markets/NCD/actions/ProductBouquetActions";
import TransactionJourneyActions from "@redux/feature/Markets/NCD/actions/TransactionJourneyActions";
import OrderBookActions from "@redux/feature/Markets/NCD/actions/OrderBookActions";
import RegisterLeadActions from "@redux/feature/Markets/NCD/actions/RegisterLeadActions";
export default (function () {
    return {
        transactionJourney: new TransactionJourneyActions(),
        productBouquet: new ProductBouquetActions(),
        orderBook: new OrderBookActions(),
        registerLead: new RegisterLeadActions(),
    };
});
